import { render, staticRenderFns } from "./NotificationBarMessage.vue?vue&type=template&id=94a7f52a&scoped=true"
import script from "./NotificationBarMessage.vue?vue&type=script&lang=js"
export * from "./NotificationBarMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationBarMessage.vue?vue&type=style&index=0&id=94a7f52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a7f52a",
  null
  
)

export default component.exports